<template functional>
    <sidebar-tab>
        <form-row>
            <form-field>
                <iframe class="tw-mt-3 tw-rounded tw-overflow-hidden tw-max-w-full" :src="'https://maps.google.com/maps?q=' + props.tEvent.lat + ',' + props.tEvent.long +'&amp;output=embed'" v-if="props.tEvent.long !== null && props.tEvent.lat !== null" height="250" frameborder="0" scrolling="no" marginheight="0" marginwidth="0"></iframe>
            </form-field>
        </form-row>
    </sidebar-tab>
</template>

<script>
    export default {
        name: 'EventsSidebarMaps',

        props: {
            tEvent: {
                required: true,
            },
        },
    };
</script>